export enum DevicesStatus {
    ONLINE = 'online',
    OFFLINE = 'offline',
}